export default "__VITE_ASSET__BEYBpqHV__"